import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ValueProps from "@/components/ValueProps";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Destinations from "@/components/Destinations";
import Testimonials from "@/components/Testimonials";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-[#FDFDFD]" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <ValueProps />
        <Services />
        <Manifesto />
        <Destinations />
        <Testimonials />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
